import React from 'react'
import { Controller, useFormState } from 'react-hook-form'
import { TimePicker } from 'antd'
import dayjs from 'dayjs'

// Composant pour le cas isActiveSubmit = true
const ActiveTimePickerField = ({ field, control, setValue }) => {
  const { errors, isSubmitted } = useFormState({ control })
  const error = errors[field.idFieldCanvas]
  let pickerClass = ''
  let defaultRange = null

  if (
    field.VALUE__reponse &&
    field.VALUE__reponse !== undefined &&
    field.VALUE__reponse !== 'null'
  ) {
    defaultRange = field.VALUE__reponse
      ? dayjs(field.VALUE__reponse, 'HH:mm:ss')
      : null
  }

  if (isSubmitted) {
    pickerClass = error ? 'input-error' : 'input-success'
  }

  const input_style = field.input_design ? { ...field.input_design } : {}

  const TimePickerRender = ({ onChange = () => {}, value }) => (
    <TimePicker
      className={pickerClass}
      style={input_style}
      placeholder={field.placeholder || ''}
      value={value}
      format="HH:mm:ss"
      onChange={(time, timeString) => {
        onChange(time)
      }}
    />
  )

  return (
    <Controller
      control={control}
      name={field.idFieldCanvas}
      rules={{ required: field.required }}
      render={({ field: { onChange, value } }) => (
        <TimePickerRender onChange={onChange} value={value} />
      )}
      defaultValue={defaultRange}
    />
  )
}

// Composant pour le cas isActiveSubmit = false
const InactiveTimePickerField = ({ field }) => {
  const input_style = field.input_design ? { ...field.input_design } : {}

  const TimePickerRender = () => (
    <TimePicker placeholder={field.placeholder || ''} style={input_style} />
  )

  return <TimePickerRender />
}

const TimePickerField = ({ field, control, setValue, isActiveSubmit }) => {
  return isActiveSubmit ? (
    <ActiveTimePickerField
      field={field}
      control={control}
      setValue={setValue}
    />
  ) : (
    <InactiveTimePickerField field={field} />
  )
}

export default TimePickerField
